// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".channel-icon[data-v-bb67c978]{width:26px;height:26px;box-shadow:0 2px 4px 0 rgba(0,0,0,.12);background:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
